import { service } from '../../../helpers/http'

export const ActionIndexImportLog = ({ dispatch }, payload ) => { 
	return service({ 
		module: 'importLog', 
		action: 'index', 
		payload: payload 
	})
} 